var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRegistration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3483_8390)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 4,
    fill: "#F3FAFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.2907,
    y: 20.6911,
    width: 47.2094,
    height: 65.4095,
    rx: 5.6,
    fill: "#F3FAFD",
    stroke: "#008BFF",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 20.5001C23.5 17.4073 26.0072 14.9001 29.1 14.9001H65.1093C68.2021 14.9001 70.7093 17.4073 70.7093 20.5001V74.7096C70.7093 77.8024 68.2021 80.3096 65.1093 80.3096H29.1C26.0072 80.3096 23.5 77.8024 23.5 74.7096V20.5001Z",
    fill: "white",
    stroke: "#008BFF",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.309 28.6414C31.3106 28.6414 30.6066 28.123 30.6066 26.9454V24.4494H31.541V26.875C31.541 27.5406 31.861 27.8158 32.309 27.8158C32.7634 27.8158 33.0834 27.5406 33.0834 26.875V24.4494H34.0178V26.9454C34.0178 28.123 33.3138 28.6414 32.309 28.6414ZM37.2609 28.5454L36.1281 26.9646H35.9105V28.5454H34.9761V24.4494H36.5761C37.2929 24.4494 38.0353 24.8526 38.0353 25.7102C38.0353 26.3374 37.6257 26.7022 37.0753 26.8622L38.3937 28.5454H37.2609ZM35.9105 25.1534V26.2798H36.3713C36.8321 26.2798 37.0753 26.075 37.0753 25.723C37.0753 25.3774 36.8321 25.1534 36.3457 25.1534H35.9105ZM39.9355 27.7646H41.4587V28.5454H39.0011V24.4494H39.9355V27.7646Z",
    fill: "#008BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.1458,
    y: 33.9546,
    width: 33.0911,
    height: 1.65456,
    rx: 0.827278,
    fill: "#008BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.1458,
    y: 38.9185,
    width: 33.0911,
    height: 1.65455,
    rx: 0.827277,
    fill: "#008BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.1458,
    y: 43.8823,
    width: 20.6819,
    height: 1.65456,
    rx: 0.827278,
    fill: "#008BFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.309,
    cy: 44.7093,
    rx: 0.827277,
    ry: 0.827278,
    transform: "rotate(180 53.309 44.7093)",
    fill: "#008BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.5458,
    y: 51.7276,
    width: 10.7819,
    height: 10.7819,
    rx: 1.2,
    fill: "#F3FAFD",
    stroke: "#008BFF",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.2276,
    y: 50.0729,
    width: 11.6092,
    height: 11.6092,
    rx: 5.80458,
    fill: "#F3FAFD",
    stroke: "#008BFF",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.479 63.8549C46.9409 63.0549 48.0956 63.0549 48.5575 63.8549L53.6671 72.705C54.129 73.505 53.5516 74.505 52.6279 74.505H42.4087C41.4849 74.505 40.9076 73.505 41.3694 72.705L46.479 63.8549Z",
    fill: "#F3FAFD",
    stroke: "#008BFF",
    strokeWidth: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3483_8390"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 4,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistration);
export default __webpack_public_path__ + "static/media/Registration.652940f829ed98dcf64cba1c703d9d54.svg";
export { ForwardRef as ReactComponent };